import { panoramaImagePath } from "@nova/util-s3"
import { normalize } from "@nova/util-strings"
import { fileManagementApi } from "features/data-management/files/fileManagementApi"

export const panoramaImageS3Key = (
    portfolioId: string | undefined,
    fireId: string | undefined,
    flightId: string | undefined,
    filename: string,
    isDemo?: boolean
) => {
    return isDemo
        ? `public/sample-data/flight/${flightId}/images/${filename}`
        : panoramaImagePath(portfolioId!, fireId!, flightId!, filename)
}

export const createPanoramaImageUrl = async (
    orgId: string,
    fireId: string,
    flightId: string,
    filename: string,
    isDemo?: boolean
) => {
    const s3Key = panoramaImageS3Key(orgId, fireId, flightId, normalize(filename), isDemo)

    return await fileManagementApi.getDownloadUrl(s3Key, { isDemo })
}
